import React, { useEffect, useState } from "react";
import { Modal, Button } from "antd";
import styled from "@emotion/styled";
import { useNavigate, useLocation } from "react-router-dom";

const CookieModal = () => {
  const navigate = useNavigate();
  const [visible, setVisible] = useState(false);
  const { pathname } = useLocation();

  const isAcceptCookiePolicy = () => {
    const isAccept = localStorage.getItem("isAcceptCookiePolicy");
    return isAccept && isAccept === "true";
  };
  useEffect(() => {
    setVisible(
      !isAcceptCookiePolicy() &&
        !["/cookiePolicy", "/privacyNotice"].includes(pathname)
    );
  }, [pathname]);
  return (
    <CModal
      title={<SubTopic>ยินยอมให้ใช้คุกกี้</SubTopic>}
      visible={visible}
      closable={false}
      footer={null}
    >
      <p>
        เว็บแอปพลิเคชัน เณรกล้า โภชนาดี ใช้คุกกี้
        เพื่อบันทึกข้อมูลการเข้าสู่ระบบหรือยืนยันตัวตน
        หรือให้ท่านสามารถเข้าถึงฟังก์ชันบางประการได้
        ท่านสามารถดูข้อมูลเพิ่มเติมได้ที่{" "}
        <Link onClick={() => navigate("/cookiePolicy")}>นโยบายคุกกี้</Link> หรือ{" "}
        <Link onClick={() => navigate("/privacyNotice")}>
          คำประกาศเกี่ยวกับความเป็นส่วนตัว
        </Link>
      </p>
      <center>
        {" "}
        <ConfirmBtn
          onClick={() => {
            localStorage.setItem("isAcceptCookiePolicy", "true");
            setVisible(false);
          }}
        >
          ตกลง
        </ConfirmBtn>
      </center>
    </CModal>
  );
};

export default CookieModal;

const CModal = styled(Modal)`
  font-family: "Noto Sans Thai", "Noto Sans";
`;

const BoldText = styled.span`
  font-weight: 700;
`;

const Link = styled(BoldText)`
  color: #ff6a40;
  cursor: pointer;
`;

const SubTopic = styled.span`
  color: #047751;
  font-size: 24px;
`;

const ConfirmBtn = styled(Button)`
  border-radius: 100px;
  padding: 14px 32px;
  width: 206px;
  height: 51px;
  color: #ffffff;
  background: #16af7b;
  font-family: Noto Sans Thai, Noto Sans;
  font-style: normal;
  font-weight: bold;
  font-size: 19px;
  line-height: 23px;
  letter-spacing: -0.02em;

  &:disabled {
    background: #d0d5dd;
    color: #64748b;
  }

  &.ant-btn:hover,
  &.ant-btn:focus {
    color: #16af7b;
    border-color: #16af7b;
  }
`;
